var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 10C3.33325 14.1421 6.69117 17.5 10.8333 17.5C14.9753 17.5 18.3333 14.1421 18.3333 10H10.8333H3.33325Z",
    fill: "#DC4C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 2.5V10H18.3333C18.3333 5.85792 14.9753 2.5 10.8333 2.5Z",
    fill: "#F7A278"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 2.5C6.69117 2.5 3.33325 5.85792 3.33325 10H10.8333V2.5Z",
    fill: "#C06346"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29966 14.1667H2.36716C1.9805 14.1667 1.66675 13.8529 1.66675 13.4662V6.53375C1.66675 6.14708 1.9805 5.83333 2.36716 5.83333H9.29966C9.68633 5.83333 10.0001 6.14708 10.0001 6.53375V13.4662C10.0001 13.8529 9.68633 14.1667 9.29966 14.1667Z",
    fill: "#9B341F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11383 7.92167H4.16675V12.0883H5.01008V10.6212H5.95841C6.74008 10.6212 7.37383 9.9875 7.37383 9.20583V9.18167C7.37383 8.48583 6.80966 7.92167 6.11383 7.92167ZM6.48758 9.31583C6.48758 9.67375 6.19716 9.96417 5.83925 9.96417H5.01008V8.57875H5.83925C6.19716 8.57875 6.48758 8.86917 6.48758 9.22708V9.31583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/Power.9510c2bd82da19923cac303af42ea563.svg";
export { ForwardRef as ReactComponent };